/**
 * Labstep
 *
 * @module state/actions/thumbnail
 * @desc Redux actions for thumbnail
 */

import type { APICallOptions } from 'labstep-web/models';
import type { Action } from 'labstep-web/models/action.model';
import { ReduxStateService } from 'labstep-web/services/redux-state.service';

export const thumbnailFetchUrlAction = (
  fileGuid: string,
  params: Record<string, unknown>,
  options: APICallOptions,
): Action => ({
  type: 'SERVERLESS_REQUEST_THUMBNAIL',
  meta: {
    fileGuid,
    params,
    key: `${fileGuid}-${ReduxStateService.stringifyParamsInOrder(params)}`,
  },
  ...options,
});

export const thumbnailErrorAction = (
  fileGuid: string,
  params: Record<string, unknown>,
  options: APICallOptions,
): Action => ({
  type: 'THUMBNAIL_ERROR',
  meta: {
    fileGuid,
    params,
    key: `${fileGuid}-${ReduxStateService.stringifyParamsInOrder(params)}`,
  },
  ...options,
});

export const REFRESH_THUMBNAIL_STATUSES_ACTION_TYPE =
  'REFRESH_THUMBNAIL_STATUSES';
